import { getJson, patchJson } from './backendClient';

const authHeader = (accessToken) => ({ Authorization: `Bearer ${accessToken}` });

export const loadUserSettings = (accessToken) =>
	getJson('/api/user-settings', { headers: authHeader(accessToken) });

export const saveTheme = (accessToken, theme) =>
	patchJson('/api/user-settings', { theme }, { headers: authHeader(accessToken) });

export const saveLanguage = (accessToken, language) =>
	patchJson('/api/user-settings', { language }, { headers: authHeader(accessToken) });
